import {CompGetVatBankAccountsApiResponse} from '@dms/api/customer';

import {formatIban} from './formatIban';
import {formatLocalAccount} from './formatLocalAccount';

const emptyAccount = {
  id: null,
  bankAccountData: {
    name: null,
    countryCode: null,
    ownerName: null,
    iban: null,
    swiftBic: null,
    currency: null,
    number: null,
    bankCode: null,
    isDeleted: null,
  },
};

const createBankAccountData = (
  params: {number: string; bankCode: string} | {iban: string | null}
) => {
  if ('iban' in params) {
    return {
      id: null,
      bankAccountData: {
        ...emptyAccount.bankAccountData,
        iban: params.iban,
      },
    };
  }

  return {
    id: null,
    bankAccountData: {
      ...emptyAccount.bankAccountData,
      number: params.number,
      bankCode: params.bankCode,
      // we are always assuming 'CZE' and 'CZK' for 'local' bank accounts
      countryCode: 'CZE',
      currency: 'CZK',
    },
  };
};

export const formatGetVatBankAccounts = (accounts: CompGetVatBankAccountsApiResponse) => {
  if (!accounts?.account) {
    return [];
  }

  const filteredAccounts = accounts.account.filter(Boolean);

  if (filteredAccounts.length === 0) {
    return [];
  }

  return filteredAccounts.map((account) => {
    if (account?.type === 'local') {
      const prefix = account.prefix || '';
      const accountNumber = account.account || '';
      const bankCode = account.bankCode || '';

      const formattedLocalNumber = formatLocalAccount({accountNumber, bankCode, prefix});

      return createBankAccountData({number: formattedLocalNumber, bankCode});
    }

    if (account?.type === 'international') {
      const iban = formatIban(account.account);
      return createBankAccountData({iban});
    }

    return emptyAccount;
  });
};
